import styled from 'styled-components';

export const FooterContainer = styled.div`
    height: 50px;
    width: auto;
    display: flex;
    justify-content: center;
    background-color: #41B3A3;
`

export const FooterWrapper = styled.div`
    position: relative;
    text-align: center;
`
export const FooterHeader = styled.div`
    color: white;
    position: relative;
    margin: 15px 0px 0px 0px;
    
`